import './style.scss';
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import gsap from 'gsap';
import { Draggable } from "gsap/Draggable";
import imagesloaded from 'imagesloaded';

jQueryBridget( 'imagesloaded', imagesloaded, $ );

gsap.registerPlugin(Draggable);

function heroSliderFunction() {
	if($(".wp-block-krutablocks-hero-slider").length > 0) {
	    $(".wp-block-krutablocks-hero-slider").each(function() {
	    	const self = $(this),
			slides = self.find(".wp-block-krutablocks-hero-slide"),
			imageWrappers = slides.find(".wp-block-krutablocks-hero-slide__image-wrapper"),
			images = slides.find(".wp-block-krutablocks-hero-slide__image"),
			sImg = slides.find(".wp-block-krutablocks-hero-slide__image img"),
			conts = slides.find(".wp-block-krutablocks-hero-slide__inner-container"),
			inners = slides.find(".wp-block-krutablocks-hero-slide__inner"),
			navIndex = self.find(".wp-block-krutablocks-hero-slider__nav-index"),
			navLength = self.find(".wp-block-krutablocks-hero-slider__nav-length");
			let moveSlideTL = gsap.timeline({paused:true}),
			nextLoop;

			function nextClick() {
				if(!moveSlideTL.isActive()) {
					var slideFrom = self.find(".wp-block-krutablocks-hero-slide.active"),
					imgWrapperFrom = slideFrom.find(".wp-block-krutablocks-hero-slide__image-wrapper"),
					imgFrom = slideFrom.find(".wp-block-krutablocks-hero-slide__image"),
					contFrom = slideFrom.find(".wp-block-krutablocks-hero-slide__inner-container"),
					innerFrom = slideFrom.find(".wp-block-krutablocks-hero-slide__inner"),
					sectionToIndex = slides.index(slideFrom);

					if(sectionToIndex !== slides.length - 1) {
						var slideTo = slides.eq(sectionToIndex + 1),
						imgWrapperTo = imageWrappers.eq(sectionToIndex + 1),
						imgTo = images.eq(sectionToIndex + 1),
						contTo = conts.eq(sectionToIndex + 1),
						innerTo = inners.eq(sectionToIndex + 1);
						moveToSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, contTo, contFrom, innerTo, innerFrom);
					} else {
						slideTo = slides.eq(0);
						imgWrapperTo = imageWrappers.eq(0);
						imgTo = images.eq(0);
						contTo = conts.eq(0);
						innerTo = inners.eq(0);
						moveToSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, contTo, contFrom, innerTo, innerFrom);
					}
					if (self.hasClass("has-autoplay")) {
			            // Stop the last one
			              nextLoop.kill();
			              // Start it again
			              looper();
			          }
				}
			}

			function prevClick() {
				if(!moveSlideTL.isActive()) {
					var slideFrom = self.find(".wp-block-krutablocks-hero-slide.active"),
					imgWrapperFrom = slideFrom.find(".wp-block-krutablocks-hero-slide__image-wrapper"),
					imgFrom = slideFrom.find(".wp-block-krutablocks-hero-slide__image"),
					contFrom = slideFrom.find(".wp-block-krutablocks-hero-slide__inner-container"),
					innerFrom = slideFrom.find(".wp-block-krutablocks-hero-slide__inner"),
					sectionToIndex = slides.index(slideFrom);

					if(sectionToIndex !== 0) {
						var slideTo = slides.eq(sectionToIndex - 1),
						imgWrapperTo = imageWrappers.eq(sectionToIndex - 1),
						imgTo = images.eq(sectionToIndex - 1),
						contTo = conts.eq(sectionToIndex - 1),
						innerTo = inners.eq(sectionToIndex - 1);
						moveFromSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, contTo, contFrom, innerTo, innerFrom);
					} else {
						slideTo = slides.eq(slides.length - 1);
						imgWrapperTo = imageWrappers.eq(slides.length - 1);
						imgTo = images.eq(slides.length - 1);
						contTo = conts.eq(slides.length - 1);
						innerTo = inners.eq(slides.length - 1);
						moveFromSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, contTo, contFrom, innerTo, innerFrom);
					}
					if (self.hasClass("has-autoplay")) {
			            // Stop the last one
			              nextLoop.kill();
			              // Start it again
			              looper();
			          }
				}
			}

			function moveToSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, contTo, contFrom, innerTo, innerFrom) {
					moveSlideTL = gsap.timeline({onUpdate: updateIndex});
					if(self.hasClass('leaf-over')) {
						moveSlideTL.to(contFrom, {duration:0.4,yPercent:-100})
						.to(innerFrom, {duration:0.4,yPercent:100}, "<")
						.to(imgFrom, {duration:1,xPercent:-100})

						.set(slideTo, {autoAlpha:1, className: "wp-block-krutablocks-hero-slide active"}, "<")
						.set(slideFrom, {className: "wp-block-krutablocks-hero-slide"}, "<")
						.fromTo(imgWrapperTo, {xPercent:100}, {duration:1,xPercent:0}, "<")
						.fromTo(imgTo, {xPercent:-100}, {duration:1,xPercent:0}, "<")
						.fromTo(contTo, {yPercent:-100}, {duration:0.4,yPercent:0})
						.fromTo(innerTo, {yPercent:100}, {duration:0.4,yPercent:0}, "<")
						.set(slideFrom, {clearProps:"all"});
					} else {
						moveSlideTL.to(contFrom, {duration:0.4,yPercent:-100})
						.to(innerFrom, {duration:0.4,yPercent:100}, "<")
						.to(imgWrapperFrom, {duration:1,xPercent:-100})
						.to(imgFrom, {duration:1,xPercent:100}, "<")

						.set(slideTo, {autoAlpha:1, className: "wp-block-krutablocks-hero-slide active"}, "<")
						.set(slideFrom, {className: "wp-block-krutablocks-hero-slide"}, "<")
						.fromTo(imgWrapperTo, {xPercent:100}, {duration:1,xPercent:0}, "<")
						.fromTo(imgTo, {xPercent:-100}, {duration:1,xPercent:0}, "<")
						.fromTo(contTo, {yPercent:-100}, {duration:0.4,yPercent:0})
						.fromTo(innerTo, {yPercent:100}, {duration:0.4,yPercent:0}, "<")
						.set(slideFrom, {clearProps:"all"});
					}
			}

			function moveFromSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, contTo, contFrom, innerTo, innerFrom) {
					moveSlideTL = gsap.timeline({onUpdate: updateIndex});
					if(self.hasClass('leaf-over')) {
						moveSlideTL.to(contFrom, {duration:0.3,yPercent:100})
						.to(innerFrom, {duration:0.3,yPercent:-100}, "<")
						.to(imgFrom, {duration:1,xPercent:100})

						.set(slideTo, {autoAlpha:1, className: "wp-block-krutablocks-hero-slide active"}, "<")
						.set(slideFrom, {className: "wp-block-krutablocks-hero-slide"}, "<")
						.fromTo(imgWrapperTo, {xPercent:-100}, {duration:1,xPercent:0}, "<")
						.fromTo(imgTo, {xPercent:100}, {duration:1,xPercent:0}, "<")
						.fromTo(contTo, {yPercent:100}, {duration:0.3,yPercent:0})
						.fromTo(innerTo, {yPercent:-100}, {duration:0.3,yPercent:0}, "<")
						.set(slideFrom, {clearProps:"all"});
					} else {
						moveSlideTL.to(contFrom, {duration:0.3,yPercent:100})
						.to(innerFrom, {duration:0.3,yPercent:-100}, "<")
						.to(imgWrapperFrom, {duration:1,xPercent:100})
						.to(imgFrom, {duration:1,xPercent:-100}, "<")

						.set(slideTo, {autoAlpha:1, className: "wp-block-krutablocks-hero-slide active"}, "<")
						.set(slideFrom, {className: "wp-block-krutablocks-hero-slide"}, "<")
						.fromTo(imgWrapperTo, {xPercent:-100}, {duration:1,xPercent:0}, "<")
						.fromTo(imgTo, {xPercent:100}, {duration:1,xPercent:0}, "<")
						.fromTo(contTo, {yPercent:100}, {duration:0.3,yPercent:0})
						.fromTo(innerTo, {yPercent:-100}, {duration:0.3,yPercent:0}, "<")
						.set(slideFrom, {clearProps:"all"});
					}
					
			}

			function updateIndex() {
				var active = slides.index($(".wp-block-krutablocks-hero-slide.active")) + 1;
				if(active.toString().length < 2) active = '0' + active;
				navIndex.text(active);
			}

			function slideIndex() {
				var active = slides.index($(".wp-block-krutablocks-hero-slide.active")) + 1,
					slideLength = slides.length;
				if(active.toString().length < 2) active = '0' + active;
				if(slideLength.toString().length < 2) slideLength = '0' + slideLength;
				navIndex.text(active);
				navLength.text(slideLength);
			}

			if(self.hasClass("is-draggable")) {
				const proxy = $('<div></div>');
				Draggable.create(proxy, {
					trigger: self,
					type: "x",
					cursor: "grab",
					activeCursor: "grabbing",
					onDrag: function() {
						if(this.deltaX > 10) {
							prevClick();
						}
						if(this.deltaX < -10) {
							nextClick();
						}
					}
				});
			}

			function looper() {
		        var autoplayTimer = self.data("autoplay");
		        nextLoop = gsap.delayedCall(autoplayTimer, function() {
		          nextClick();
		        });
		    }

		    if (self.hasClass("has-autoplay")) {
		        looper();
		    }

			function init() {
				// self.on('click', nextClick);
				// prev.on('click', prevClick);

				const activeSlide = self.find(".wp-block-krutablocks-hero-slide:first");
				gsap.set(activeSlide, {autoAlpha: 1, className: "wp-block-krutablocks-hero-slide active"});
				slideIndex();
			}
			init();

			function headerAnimation() {
			    self.on("mousemove", callMoveIn).on("mouseleave", callMoveOut);

			    // logoContainer.on("mousemove", callMoveInLogo).on("mouseleave", callMoveOutLogo);


			    function callMoveIn(e){
			      moveIn(e, self, sImg, 50);
			    }

			    function callMoveOut(){
			      moveOut(images);
			    }

			    function moveIn(e, lock, target, movement){
			      var boundingRect = lock[0].getBoundingClientRect();
			      var relX = e.clientX - boundingRect.left;
			      var relY = e.clientY - boundingRect.top;

			      gsap.to(target, {
			        duration: 1.2,
			        x: (relX - boundingRect.width/2) / boundingRect.width * movement,
			        y: (relY - boundingRect.height/2) / boundingRect.width * movement,
			        ease: "power4.out"
			      });
			    }

			    function moveOut(target){
			      gsap.to(target, {
			        duration: 1.2,
			        x: 0,
			        y: 0,
			        ease: "power4.out"
			      });
			    }
			    
			}
			if(self.hasClass('has-parallax')) {
				headerAnimation();
			}
	    })
	}
}

function heroActiveReveal() {
  if($(".wp-block-krutablocks-hero-slide.active").length) {
    var slide = $(".wp-block-krutablocks-hero-slide.active"),
        loader = $('.c-loader'),
		imageWrappers = slide.find(".wp-block-krutablocks-hero-slide__image-wrapper"),
		images = slide.find(".wp-block-krutablocks-hero-slide__image"),
		conts = slide.find(".wp-block-krutablocks-hero-slide__inner-container"),
		inners = slide.find(".wp-block-krutablocks-hero-slide__inner"),
		navs = slide.siblings(".wp-block-krutablocks-hero-slider__nav"),
        tl = gsap.timeline({paused:true});

		tl.fromTo(imageWrappers, {xPercent:100}, {duration:1,xPercent:0}, "<")
		.fromTo(images, {xPercent:-100}, {duration:1,xPercent:0}, "<")
		.fromTo(conts, {yPercent:-100}, {duration:0.3,yPercent:0})
		.fromTo(inners, {yPercent:100}, {duration:0.3,yPercent:0}, "<")
		.fromTo(navs,{autoAlpha:0},{duration:0.3,autoAlpha:1},"<");

        loader.length ? tl.play().delay(3.2) : tl.play().delay(0.4);
  }
}

$(window).on('load', () => {
  heroSliderFunction();
  heroActiveReveal();
});
